import React, { ReactNode, useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import { Box, SxProps, Theme, Typography, useTheme } from '@mui/material';

import CommonButton from './CommonButton';
import { walletState } from '@/atom/wallet';
import WalletMenu from './WalletMenu';
import { useWeb3 } from '@/hooks/use-web3';

import { ShortenAddr } from '@/lib/Shorten';
import ConnectInfo from '@/component/ConnectWallet/ConnectInfo';
import { LOCAL_SESSION, LOCAL_SESSION_TIME } from '@/lib/common/name-space';
import { localGetStorage, localSetStorage } from '@/lib/storage';
import { useLocation, useNavigate } from 'react-router-dom';
import PoolsOverview from '../pools/card/PoolsOverview';
import SymbolSvg from '@/assets/assetfi/Symbol';

interface CommonTopPropsType {
  title: string;
  subtitle: string;
  children?: ReactNode;
  avatar?: boolean;
  sx?: SxProps<Theme>;
}

const CommonTop = ({ title, subtitle, avatar, children, sx }: CommonTopPropsType) => {
  // use
  const theme = useTheme();
  const { web3authCall } = useWeb3();
  const location = useLocation();
  const navigate = useNavigate();

  // state
  const [address, setAddress] = useState('');
  const [wallet, setWallet] = useRecoilState(walletState);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    if (address) {
      return;
    }
    (async () => {
      if (web3authCall?.connected()) {
        const addr = await web3authCall.getAddress();
        setAddress(addr);
      }
    })();
    return () => {};
  }, [web3authCall, address]);

  // method
  // const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
  //   address ? setAnchorEl(event.currentTarget) : setWallet(true);
  // };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleConnect = async (event: React.MouseEvent<HTMLButtonElement>) => {
    if (address) {
      setAnchorEl(event.currentTarget);
      return;
    }
    const re = await web3authCall?.getWeb3auth().connect();
    if (re) {
      const userAccount: string[] = await web3authCall?.getRpc().getAccounts()!;
      console.log(userAccount[0]);
      if (userAccount[0]) {
        const userInfo = await web3authCall?.getUserInfo();
        console.log(userInfo?.typeOfLogin);

        const re = localGetStorage(LOCAL_SESSION);
        if (!re) {
          setSession();
          changeLoginType();
        }

        // navigate('/pools');
        const path = location.pathname;
        if (path === '/pools') {
          window.location.reload();
        } else {
          navigate('/pools');
        }
      }
    }
  };
  const setSession = () => {
    const now = new Date();
    const payload = {
      key: LOCAL_SESSION,
      value: {
        sessionTime: now.getTime() + LOCAL_SESSION_TIME,
      },
    };
    localSetStorage(payload);
  };
  const changeLoginType = async () => {
    const res = localGetStorage('snsAddress');
    if (!res) {
      return;
    }
    const re = await web3authCall!.getUserInfo();
    const loginType = re.typeOfLogin ?? 'external';
    const payload = {
      key: 'snsAddress',
      value: {
        ...res,
        typeOfLogin: loginType,
      },
    };
    localSetStorage(payload);
  };

  return (
    <Box
      sx={{
        background: theme.background.default,
        ...sx,
      }}
    >
      <Box
        sx={{
          padding: { xs: '16px 24px', md: '20px 24px' },
          display: 'flex',
          justifyContent: 'space-between',
          maxWidth: '1680px',
        }}
      >
        <Box sx={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
          {avatar && <SymbolSvg width={48} height={48} />}
          <Box>
            <Typography color={theme.greyscale.darkgrey2} variant={'h2'}>
              {title}
            </Typography>
            <Typography color={theme.greyscale.grey3} variant={'body1'}>
              {subtitle}
            </Typography>
          </Box>
        </Box>

        <CommonButton
          bgColor={address ? '#ffffff' : theme.brand.primary}
          color={address ? theme.background.blue : '#ffffff'}
          text={address ? ShortenAddr(address) : 'Connect Wallet'}
          handleClick={handleConnect}
          variant={address ? 'h6' : 'subtitle2'}
          sx={{
            display: {
              xs: 'none',
              md: 'block',
            },
            height: '36px',
            borderRadius: '10px',
            padding: '6px 20px 6px 20px',
            boxShadow: address ? '0px 0px 4px 0px #00000026' : 'none',
          }}
          icon={address ? 'symbol' : null}
        />
      </Box>

      {children}

      <ConnectInfo open={open} onClose={handleClose} anchorEl={anchorEl} />
      {/* <WalletMenu open={open} anchorEl={anchorEl} handleClose={handleClose} /> */}
    </Box>
  );
};

export default CommonTop;
